export default "__VITE_ASSET__GdEMWGae__"